import DataTable from '../../components/DataTable';
import PageHeader from '../../components/PageHeader';
import FilterPanel from '../../components/FilterPanel';
import { formatDate } from '../../utils/formatters';
import { Button, Stack, TextField, Typography } from '@mui/material';
const userIdentifier = (user) => user.userId || user.anonymousId || user.deviceId || user.id || '-';
const AppUsersPage = ({
  users,
  filters,
  setFilters,
  loadUsers,
  onDeleteUser,
  onSaveUserFullName,
  loading,
}) => {
  const columns = [
    {
      key: 'name',
      label: 'שם מלא',
      width: 250,
      render: (user) => (
        <Stack
          onSubmit={(event) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            onSaveUserFullName(user, String(formData.get('fullName') || ''));
          }}
          sx={{
            width: '220px',
            maxWidth: '100%',
            display: 'grid',
            gridTemplateColumns: 'minmax(0, 1fr) auto',
            gap: '8px',
            alignItems: 'center',
          }}
        >
          <TextField
            name="fullName"
            size="small"
            variant="standard"
            defaultValue={user.fullName || user.name || ''}
            maxLength={80}
            placeholder="שם מלא"
          />

          <Button
            type="submit"
            disabled={loading}
            sx={{
              minHeight: '30px',
              height: '30px',
              padding: '0 12px',
              fontSize: '13px',
            }}
          >
            שמירה
          </Button>
        </Stack>
      ),
    },
    {
      key: 'identifier',
      label: 'מזהה',
      render: (user) => (
        <Stack
          sx={{
            height: '100%',
            justifyContent: 'center',
          }}
        >
          <Typography
            sx={{
              fontSize: 11,
              fontWeight: 'bold',
            }}
            title={userIdentifier(user)}
          >
            {userIdentifier(user)}
          </Typography>

          <Typography
            sx={{
              fontSize: 11,
            }}
            title={userIdentifier(user)}
          >
            {user.platform || 'unknown'} · {user.deviceId || '-'}
          </Typography>
        </Stack>
      ),
    },
    {
      key: 'onboarding',
      label: 'מסך פתיחה',
      render: (user) => (user.onboarding?.completed ? '✔️' : user.onboarding?.step),
    },
    {
      key: 'reportsCount',
      label: 'כמות דיווחים',
      render: (user) => user.reportsCount || 0,
    },
    {
      key: 'points',
      label: 'נקודות',
      render: (user) => user.points || user.community?.points || 0,
    },
    {
      key: 'lastSeenAt',
      label: 'נראה לאחרונה',
      render: (user) => formatDate(user.lastSeenAt),
    },
    {
      key: 'delete',
      label: 'מחיקה מהמאגר',
      render: (user) => (
        <Button
          type="button"
          disabled={loading}
          onClick={(event) => {
            event.stopPropagation();
            onDeleteUser(user);
          }}
          sx={{
            borderRightColor: '#d92d20',
            background: '#fee4e2',
            color: 'var(--danger)',
            '&:disabled': {
              opacity: '.45',
              cursor: 'not-allowed',
              transform: 'none',
            },
            minHeight: '30px',
            height: '30px',
            padding: '0 12px',
            fontSize: '13px',
          }}
        >
          מחיקה
        </Button>
      ),
    },
  ];
  return (
    <Stack
      dir="rtl"
      sx={{
        display: 'grid',
        gap: '22px',
        direction: 'rtl',
        height: '100%',
        minHeight: '0',
        gridTemplateRows: 'auto minmax(0, 1fr) auto',
        overflow: 'hidden',
      }}
    >
      <PageHeader title="משתמשים" meta={`(${users.total || 0})`}>
        <FilterPanel>

          <TextField
            placeholder="חיפוש לפי מזהה, מכשיר או פלטפורמה"
            value={filters.userSearch}
            onChange={(event) =>
              setFilters({
                ...filters,
                userSearch: event.target.value,
              })
            }
            fullWidth
          />
        </FilterPanel>
      </PageHeader>

      <DataTable
        columns={columns}
        items={users.items}
        rowKey={(user) => user.id}
        page={users.page}
        limit={users.limit}
        total={users.total}
        onPageChange={loadUsers}
        loading={loading}
      />
    </Stack>
  );
};
export default AppUsersPage;
